import { render, staticRenderFns } from "./PayItems.vue?vue&type=template&id=1f93b1e8&scoped=true"
import script from "./PayItems.vue?vue&type=script&lang=js"
export * from "./PayItems.vue?vue&type=script&lang=js"
import style0 from "./PayItems.vue?vue&type=style&index=0&id=1f93b1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93b1e8",
  null
  
)

export default component.exports